import React, { useEffect, useState } from 'react';
import { getForms } from '../../actions/formActions';
import { listTrackingTrade } from '../../actions/zerodhaActions';
import { useSelector, useDispatch } from 'react-redux';
import Listing from '../../components/Common/Listing/Listing';
import _ from 'lodash'

const TrackTradeAlert = () => {
    const listFormKey = "ZERODHA_trade_tracking_list_form";
    const dispatch = useDispatch();
    const zerodhaState = useSelector((state) => state.zerodha);
    const formState = useSelector((state) => state.forms);
    const { formJson = {} } = formState;
    const listForm = formJson[listFormKey];
    const { trackTradeListing = {} } = zerodhaState;
    const [fetchingList, setFetchingList] = useState(true);
    const { headers = [], data: listData = [], meta = {} } = trackTradeListing;

    useEffect(() => {
        setFetchingList(true);
        dispatch(getForms(listFormKey));
    }, [])

    useEffect(() => {
        if (!_.isEmpty(trackTradeListing) && fetchingList) {
            setFetchingList(false);
        }
    }, [trackTradeListing])

    useEffect(() => {
        if (!_.isEmpty(listForm)) {
            dispatch(listTrackingTrade({}, listFormKey));
        }
    }, [listForm]);

    const handleSearch = () => {
        dispatch(listTrackingTrade({}, listFormKey));
    }

    return (
        <div style={{ position: 'relative', paddingBottom: '0px' }}> {/* Added padding-bottom */}
            <Listing
                headers={headers}
                data={listData}
                onSearch={handleSearch}
                meta={meta}
                fetchingList={fetchingList}
            />
        </div>
    );
};

export default TrackTradeAlert;